<template>
  <v-checkbox
    v-model="localValue"
    :class="['input']"
    color="primary"
    dense
    :filled="input.filled"
    item-color="accent"
    item-text="display"
    item-value="value"
    :label="input.displayName"
    placeholder=" "
    :disabled="disabled"
    :rounded="input.rounded"
  />
</template>

<script>
export default {
  name: "CheckBox",

  props: {
    input: {
      type: Object,
      required: false,
    },
    disabled: Boolean,
  },

  data: () => ({}),

  computed: {
    localValue: {
      get() {
        return this.input.value
      },
      set(newValue) {
        this.$emit("update:value", newValue)
      },
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
.input {
  margin-bottom: -30px;
}
</style>
